import { useEffect, useState, type FC } from 'react';

import { Button, Modal, Tabs, Typography } from 'pixel-react';

import { TermsTabsData } from '@/config/constants';

import Eula from './Eula';
import PrivacyPolicy from './PrivacyPolicy';
import styles from './Terms.module.scss';
import TermOfUse from './TermsOfUse';
import type { TermsModalProps } from './types';

const Terms: FC<TermsModalProps> = ({
  termsModalOpen,
  setTermsModalOpen,
  selectedTermsTab,
}) => {
  const [activeTabIdDefault, setActiveTabIdDefault] =
    useState<string>('terms-of-use');

  const renderTabContent = (tabId: string) => {
    switch (tabId) {
      case 'terms-of-use':
        return <TermOfUse setSelectedTab={setActiveTabIdDefault} />;
      case 'privacy-policy':
        return <PrivacyPolicy />;
      case 'eula':
        return <Eula />;
      default:
        return <TermOfUse setSelectedTab={setActiveTabIdDefault} />;
    }
  };

  useEffect(() => setActiveTabIdDefault(selectedTermsTab), [selectedTermsTab]);

  return (
    <Modal
      isOpen={termsModalOpen}
      customWidth="1200px"
      customHeight="640px"
      onClose={() => setTermsModalOpen(false)}
      isHeaderDisplayed={false}
      isFooterDisplayed={false}
    >
      <div className={styles.terms_policy_eula_container}>
        <div className={styles.terms_policy_eula_header}>
          <Tabs
            variant="capsule"
            activeTabId={activeTabIdDefault}
            onTabClick={setActiveTabIdDefault}
            tabsData={TermsTabsData}
          />
        </div>
        <div className={styles.terms_policy_eula_content}>
          {renderTabContent(activeTabIdDefault)}
        </div>
        <div className={styles.terms_policy_eula_footer}>
          <Button
            variant="primary"
            onClick={() => setTermsModalOpen(false)}
            buttonHeight="38px"
            buttonWidth="104px"
          >
            <Typography
              fontSize="14px"
              lineHeight="22px"
              fontWeight="semi-bold"
              color="var(--ff-white-color)"
            >
              Close
            </Typography>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Terms;
